import MessageBusTransport from '@central-products/message-transport-bus';
import { bootstrap } from '@central-products/bootstrapper';
import { feature as liveMessagingFlowFeature } from '@central-products/live-messaging-flow';
import { LiveMessagingFlowConfig } from '@central-products/live-messaging-flow';
import { anonymousAccountInfoFeature } from './anonymousAccountInfo';

// Sets up window.WH.bootstrapper.features['live-messaging-flow'] on this page, mirroring how
// registration-com-standalone (CJ monorepo) initializes the Genesys live-messaging-flow feature —
// see packages/registration-com-standalone/src/integration.ts for the full-featured equivalent.
// account-verification-frontend only needs the chat feature itself (no login/registration flows),
// so an anonymous account-info stub is used instead of the full CAS session/GraphQL stack.
export const initializeLiveMessaging = async (config: LiveMessagingFlowConfig | undefined): Promise<void> => {
  if (!config) {
    return;
  }

  try {
    const { init } = bootstrap(
      MessageBusTransport.getInstance(),
      [anonymousAccountInfoFeature, liveMessagingFlowFeature],
      {
        [anonymousAccountInfoFeature.name]: {},
        [liveMessagingFlowFeature.name]: config,
      }
    );

    await init();
  } catch (error) {
    (window.consoleReference || window.console).error(
      'Failed to initialize Live Messaging (Genesys) bootstrapper feature:',
      error
    );
  }
};
